import apiClient from './client';

// ─── Lead Documents ─────────────────────────────────────────────────────────

export const uploadLeadDocument = async (leadId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post(
    `/api/v1/leads/${leadId}/documents`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const getLeadDocuments = async (leadId) => {
  const response = await apiClient.get(`/api/v1/leads/${leadId}/documents`);
  return response.data;
};

export const getLeadDocument = async (leadId, docId) => {
  const response = await apiClient.get(`/api/v1/leads/${leadId}/documents/${docId}`);
  return response.data;
};

export const deleteLeadDocument = async (leadId, docId) => {
  const response = await apiClient.delete(`/api/v1/leads/${leadId}/documents/${docId}`);
  return response.data;
};

// ─── Brain Documents ────────────────────────────────────────────────────────

export const uploadBrainDocument = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post(
    `/api/v1/brain/documents/upload`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const getBrainDocuments = async () => {
  const response = await apiClient.get(`/api/v1/brain/documents`);
  return response.data;
};

export const getBrainDocument = async (docId) => {
  const response = await apiClient.get(`/api/v1/brain/documents/${docId}`);
  return response.data;
};

export const deleteBrainDocument = async (docId) => {
  const response = await apiClient.delete(`/api/v1/brain/documents/${docId}`);
  return response.data;
};

export const reprocessLeadDocument = async (leadId, docId) => {
  const response = await apiClient.post(`/api/v1/leads/${leadId}/documents/${docId}/reprocess`, {});
  return response.data;
};

export const reprocessBrainDocument = async (docId) => {
  const response = await apiClient.post(`/api/v1/brain/documents/${docId}/reprocess`, {});
  return response.data;
};
